var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('span',[_vm._v("深圳市云智汇科技有限公司")]),_c('span',[_vm._v("Copyright © 乐象有品 2020")])])}]

export { render, staticRenderFns }